<div
  class="fixed bottom-0 z-10 max-w-[480px] rounded-tl-3xl rounded-tr-3xl bg-white shadow-2xl shadow-black">
  <div class="mt-auto flex w-[100vw] max-w-[480px] justify-around px-2">
    <a
      [routerLink]="['/home']"
      routerLinkActive="active"
      class="flex flex-col items-center px-1 py-3 hover:text-blue-400">
      <market-icon iconName="home" [attr]="iconAttr"></market-icon>
      <span class="whitespace-nowrap text-xs">Trang chủ</span>
    </a>
    @if (role === permission.shop) {
      <a
        [routerLink]="['/nutrishop', 'profile']"
        routerLinkActive="active"
        class="flex flex-col items-center px-1 py-3 hover:text-blue-400">
        <market-icon iconName="shopping-bag" [attr]="iconAttr"></market-icon>
        <span class="whitespace-nowrap text-xs">Nutrishop</span>
      </a>
    }
    <a
      [routerLink]="['/orders', 'cart']"
      routerLinkActive="active"
      class="flex flex-col items-center px-1 py-3 hover:text-blue-400">
      <span class="indicator">
        <market-icon iconName="shopping-cart" [attr]="iconAttr"></market-icon>
        <div class="badge indicator-item badge-primary badge-xs">
          {{ totalItem() }}
        </div>
      </span>
      <span class="whitespace-nowrap text-xs"> Giỏ hàng </span>
    </a>
    @if (count$ | async; as count) {
      <a
        [routerLink]="['/orders', 'history']"
        routerLinkActive="active"
        [queryParams]="{ status: orderStatus.PENDING, skipRecord: true }"
        class="flex flex-col items-center px-1 py-3 hover:text-blue-400">
        <span class="indicator">
          <market-icon iconName="truck" [attr]="iconAttr"></market-icon>
          @if (count.pending) {
            <div class="badge indicator-item badge-primary badge-xs">
              {{ count.pending > 99 ? '99+' : count.pending }}
            </div>
          }
        </span>
        <span class="whitespace-nowrap text-xs"> Đơn hàng </span>
      </a>
    }
    <a
      [routerLink]="['/user']"
      routerLinkActive="active"
      class="flex flex-col items-center px-1 py-3 hover:text-blue-400">
      <market-icon iconName="user" [attr]="iconAttr"></market-icon>
      <span class="whitespace-nowrap text-xs"> Cá nhân </span>
    </a>
  </div>
</div>
